module.exports = __webpack_public_path__ + "img/1_029.039b6e47.jpg";